import React from 'react'
import { Link } from 'react-router-dom'
import $ from 'jquery'
import Constant from '../../../Constant.js'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import axios from 'axios'
import ActivitiesController from '../../../common/activitiesController/ActivitiesController.js'

class GovernorateList extends React.Component {
  state = {
    governorate_data: [
      {
        governateId: '',
        name_en: '',
        name_ar: '',
        country: {
          id: '',
          country_name_en: '',
        },
      },
    ],
  }

  handleStatusChange = (sid) => {
    var isChecked = $('#cattogBtn_' + sid)
    isChecked.prop('checked', !isChecked.prop('checked'))
    var status = 'inactive'
    if (!isChecked.prop('checked') === true) {
      status = 'active'
    } else {
      status = 'inactive'
    }
    let newArray = this.state.governorate_list
    var a = newArray.find((element) => {
      return element.id === sid
    })
    a.status = status
    this.setState({ governorate_list: newArray })
    Swal.fire('Update Status!', 'Status has been updated.', 'success')
  }

  deleteGovernorate = (id) => {
    var token = `Bearer ${localStorage.getItem('loged_In_auth')}`

    axios
      .delete(Constant.getAPI() + `/admin/delete-state/${id}`, {
        headers: { Authorization: token, country_short_name: `${localStorage.getItem('countryShortName')}` },
      })
      .then(() => {
        Swal.fire({
          title: 'Item Deleted Successfully!',
          icon: 'success',
          text: '',
          type: 'success',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
        this.statesList()
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  componentDidMount() {
    this.statesList()
  }

  statesList = async () => {
    var that = this
    await axios
      .get(Constant.getAPI() + `/admin/states`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            governorate_data: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    const columns = [
      {
        name: 'name_en',
        label: 'Governorate Name : English',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'name_ar',
        label: 'Governorate Name : Arabic',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'country',
        label: 'Country Name',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (Country) => {
            return (
              <div>{Country !== undefined && Country !== null && Country !== {} ? Country.country_name_en : ''}</div>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (governateId) => {
            // var governateId = governate[0].governateId;
            return (
              <div>
                <Link
                  to={'/governorate/add/' + governateId}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                <span
                  onClick={this.deleteGovernorate.bind(this, governateId)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span>
                <ActivitiesController refId={governateId}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Governorate Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Governorate List</h4>
                    </div>
                  </div>
                  <Link
                    to="/governorate/add"
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    {' '}
                    <i className="icofont icofont-plus m-r-5"></i> Add Governorate
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Governorate List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Governorate List'}
                          className="table-responsive"
                          data={this.state.governorate_data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default GovernorateList
